'use client';

import React, { memo } from 'react';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/ChatGPT_Image_May_30__2026__02_26_11_PM-1780548208145.png',
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = ['flex items-center', onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : '', className].filter(Boolean).join(' ');

  return (
    <div className={containerClassName} onClick={onClick}>
      <AppImage
        src={src}
        alt="tolettu.com logo"
        width={size}
        height={size}
        className="flex-shrink-0 object-contain"
        priority={true}
      />
    </div>
  );
});

export default AppLogo;
